'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Node = require('./binary-search-tree-node.js');

var BinarySearchTree =
/*#__PURE__*/
function () {
  function BinarySearchTree() {
    _classCallCheck(this, BinarySearchTree);

    this.root = null;
    this.replacementNode = null;
  }

  _createClass(BinarySearchTree, [{
    key: "insert",
    value: function insert(value, cb) {
      if (!this.isNumericInput(value)) {
        return undefined;
      }

      value = Number(value);
      var newNode = new Node(value);

      if (this.treeIsEmpty()) {
        this.root = newNode;
        return newNode;
      }

      var go = function go(node) {
        if (cb) {
          cb();
        }

        if (node.value === value) {
          return undefined;
        } // already in tree


        if (!node.left && value < node.value) {
          node.left = newNode;
          return newNode;
        }

        if (!node.right && value > node.value) {
          node.right = newNode;
          return newNode;
        }

        if (value > node.value) {
          return go(node.right);
        }

        return go(node.left);
      };

      return go(this.root);
    }
  }, {
    key: "remove",
    value: function remove(value, cb) {
      if (this.treeIsEmpty()) {
        return undefined;
      }

      if (!this.isNumericInput(value)) {
        return undefined;
      }

      value = Number(value);

      if (this.root.value === value) {
        this.root = this.removeRootFromTree(this.root);
      } else {
        var parentNode = this.findParent(value, cb);

        if (!parentNode) {
          return undefined;
        } // value not in tree


        if (value < parentNode.value) {
          parentNode.left = this.removeRootFromTree(parentNode.left, cb);
        } else {
          parentNode.right = this.removeRootFromTree(parentNode.right, cb);
        }
      }

      var result = this.deletedNode;
      this.deletedNode = undefined;
      result.left = null;
      result.right = null;
      return result;
    }
  }, {
    key: "removeRootFromTree",
    value: function removeRootFromTree(root, cb) {
      this.deletedNode = root;

      if (!root.left && !root.right) {
        return null;
      }

      if (!root.left) {
        return root.right;
      }

      if (!root.right) {
        return root.left;
      }

      var replacementNodeDirection = this.pickASide();
      var newRoot; // replacement side has 1 child

      if (replacementNodeDirection === 'left' && this.subTreeRootIsMax(root.left)) {
        newRoot = root[replacementNodeDirection];
        newRoot.right = root.right;
        return newRoot;
      }

      if (replacementNodeDirection === 'right' && this.subTreeRootIsMin(root.right)) {
        newRoot = root[replacementNodeDirection];
        newRoot.left = root.left;
        return newRoot;
      } // replacement side has 2 children


      return this.removeMinOrMax(root, replacementNodeDirection, cb);
    }
  }, {
    key: "getOppositeDirection",
    value: function getOppositeDirection(direction) {
      var oppositeDirection;

      if (direction === 'left') {
        oppositeDirection = 'right';
      } else {
        oppositeDirection = 'left';
      }

      return oppositeDirection;
    }
  }, {
    key: "removeMinOrMax",
    value: function removeMinOrMax(root, replacementDir, cb) {
      var newRoot;
      var oppositeDir = this.getOppositeDirection(replacementDir); // find max or min node and remove it from the subtree

      var current = root[replacementDir];

      while (current[oppositeDir][oppositeDir]) {
        if (cb) {
          cb();
        }

        current = current[oppositeDir];
      }

      newRoot = current[oppositeDir];

      if (newRoot[replacementDir]) {
        current[oppositeDir] = newRoot[replacementDir];
      } else {
        current[oppositeDir] = null;
      }

      newRoot.left = root.left;
      newRoot.right = root.right;
      return newRoot;
    }
  }, {
    key: "subTreeRootIsMax",
    value: function subTreeRootIsMax(node) {
      if (!node.right) {
        return true;
      }

      return false;
    }
  }, {
    key: "subTreeRootIsMin",
    value: function subTreeRootIsMin(node) {
      if (!node.left) {
        return true;
      }

      return false;
    }
  }, {
    key: "remove_bad",
    value: function remove_bad(value, cb) {
      if (cb) {
        cb();
      }

      if (this.treeIsEmpty()) {
        return undefined;
      }

      if (!this.isNumericInput(value)) {
        return undefined;
      }

      value = Number(value); // if root is removed

      if (this.root.value === value) {
        var newRoot = this.removeRootFromTreeBad(this.root);
        this.root = newRoot;
      }

      var parentNode = this.findParent(value, cb);
      var deletedNode;

      if (!parentNode) {
        return undefined;
      }

      if (value < parentNode.value) {
        deletedNode = parentNode.left;
        parentNode.left = this.removeRootFromTreeBad(parentNode.left);
      } else {
        deletedNode = parentNode.right;
        parentNode.right = this.removeRootFromTreeBad(parentNode.right);
      }

      return deletedNode;
    }
  }, {
    key: "removeRootFromTreeBad",
    value: function removeRootFromTreeBad(node) {
      if (!node.left && !node.right) {
        return null;
      }

      if (!node.left) {
        return node.right;
      }

      if (!node.right) {
        return node.left;
      }

      var replacementDirection = this.pickASide();
      var newRoot = node[replacementDirection];

      if (replacementDirection === 'left') {
        var maxNodeOfLeftTree = this.findMaxNode(node.left, cb);
        maxNodeOfLeftTree.right = node.right;
      }

      if (replacementDirection === 'right') {
        var minNodeOfRightTree = this.findMinNode(node.right, cb);
        minNodeOfRightTree.left = node.left;
      }

      return newRoot;
    }
  }, {
    key: "findMax",
    value: function findMax() {
      var node = this.findMaxNode(this.root, cb);
      return node && node.value;
    }
  }, {
    key: "findMin",
    value: function findMin() {
      var node = this.findMinNode(this.root, cb);
      return node && node.value;
    }
  }, {
    key: "contains",
    value: function contains(value, cb) {
      if (this.treeIsEmpty()) {
        return false;
      }

      if (!this.isNumericInput(value)) {
        return false;
      }

      if (cb) {
        cb();
      }

      value = Number(value);

      var go = function go(node) {
        if (cb) {
          cb();
        }

        if (!node) {
          return false;
        }

        if (node.value === value) {
          return true;
        }

        if (value > node.value) {
          return go(node.right);
        }

        return go(node.left);
      };

      return go(this.root);
    }
  }, {
    key: "isNumericInput",
    value: function isNumericInput(value) {
      if (typeof value === 'boolean') {
        return false;
      }

      var numericalValue = Number(value);

      if (Number.isNaN(numericalValue)) {
        return false;
      }

      if (typeof numericalValue === 'number') {
        return true;
      }

      return false;
    }
  }, {
    key: "pickASide",
    value: function pickASide() {
      var roll = Math.random();

      if (roll > 0.5) {
        return 'left';
      }

      return 'right';
    }
  }, {
    key: "findParent",
    value: function findParent(value, cb) {
      var go = function go(node) {
        if (!node) {
          return undefined;
        }

        if (cb) {
          cb();
        }

        if (node.left && node.left.value === value) {
          return node;
        }

        if (node.right && node.right.value === value) {
          return node;
        }

        if (value > node.value) {
          return go(node.right);
        }

        return go(node.left);
      };

      return go(this.root);
    }
  }, {
    key: "findMaxNode",
    value: function findMaxNode(node, cb) {
      if (!node) {
        return undefined;
      }

      var current = node;

      while (current.right) {
        current = current.right;

        if (cb) {
          cb();
        }
      }

      return current;
    }
  }, {
    key: "findMinNode",
    value: function findMinNode(node, cb) {
      if (!node) {
        return undefined;
      }

      var current = node;

      while (current.left) {
        current = current.left;

        if (cb) {
          cb();
        }
      }

      return current;
    }
  }, {
    key: "treeIsEmpty",
    value: function treeIsEmpty() {
      if (!this.root) {
        return true;
      }

      return false;
    }
  }, {
    key: "printPreOrder",
    value: function printPreOrder() {
      var result = [];

      function go(node) {
        if (!node) {
          return;
        }

        result.push(node.value);
        go(node.left);
        go(node.right);
      }

      go(this.root);
      return result;
    }
  }, {
    key: "printInOrder",
    value: function printInOrder() {
      var result = [];

      function go(node) {
        if (!node) {
          return;
        }

        go(node.left);
        result.push(node.value);
        go(node.right);
      }

      go(this.root);
      return result;
    }
  }, {
    key: "printPostOrder",
    value: function printPostOrder() {
      var result = [];

      function go(node) {
        if (!node) {
          return;
        }

        go(node.left);
        go(node.right);
        result.push(node.value);
      }

      go(this.root);
      return result;
    }
  }]);

  return BinarySearchTree;
}();

module.exports = BinarySearchTree;